(function () {
  var limitedVariantIds = ["53985437909325", "54056547221837", "54493576692045", "54493600874829", "55225112887629"];
  var limitedProductHandles = ["multifunktionsmesser-inox-pro-11", "schweizer-fahne-84x84-cm", "usb-kabel-3-in-1-mit-usb-auf-usb-c-adapter", "snuskingdom-2-in-1-power-bank", "vika-beanie-schwarz"];
  var discountedReferenceVariantIds = ["53985437909325", "54056547221837"];
  var compactDescriptionHeadingHandles = ["snuskingdom-2-in-1-power-bank", "usb-kabel-3-in-1-mit-usb-auf-usb-c-adapter"];
  var message = "Dieses Produkt kann pro Bestellung nur 1x gekauft werden.";
  var limitedLineKeys = {};

  function isLimitedVariant(id) {
    return limitedVariantIds.indexOf(String(id)) !== -1;
  }

  function isLimitedProductPage() {
    return limitedProductHandles.some(function (handle) {
      return window.location.pathname.indexOf("/products/" + handle) !== -1;
    });
  }

  function isCompactDescriptionHeadingProductPage() {
    return compactDescriptionHeadingHandles.some(function (handle) {
      return window.location.pathname.indexOf("/products/" + handle) !== -1;
    });
  }

  function applyScopedDescriptionHeadingStyles() {
    if (!isCompactDescriptionHeadingProductPage() || document.getElementById("sk-scoped-description-heading-style")) return;

    var style = document.createElement("style");
    style.id = "sk-scoped-description-heading-style";
    style.textContent = "@media screen and (min-width: 990px) { .details-content rte-formatter.rte h2 { font-size: calc(var(--font-size--h4) - 0.2rem); line-height: 1.25; } .details-content rte-formatter.rte h3 { font-size: var(--font-size--h5); line-height: var(--font-h5--line-height); } }";
    document.head.appendChild(style);
  }

  function isLimitedCartLink(element) {
    if (!element) return false;
    return limitedProductHandles.some(function (handle) {
      return (element.querySelector && element.querySelector('a[href*="/products/' + handle + '"]')) ||
        (element.closest && element.closest('[href*="/products/' + handle + '"]'));
    });
  }

  function normalizeQuantityInput(input) {
    if (!input) return;
    input.setAttribute("max", "1");
    if (!input.value || Number(input.value) > 1) input.value = "1";
  }

  function getVariantIdFromForm(form) {
    var idInput = form && form.querySelector('[name="id"]');
    return idInput ? idInput.value : null;
  }

  function capProductPageQuantity() {
    if (!isLimitedProductPage()) return;

    document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"], quantity-input input[name="quantity"]').forEach(normalizeQuantityInput);
    document.querySelectorAll('form[action*="/cart/add"] button[name="plus"], quantity-input button[name="plus"]').forEach(function (button) {
      button.setAttribute("disabled", "disabled");
      button.setAttribute("aria-disabled", "true");
    });
  }

  function isLimitedCartNode(node) {
    if (!node || node === document) return false;
    var element = node.nodeType === 1 ? node : node.parentElement;
    if (!element) return false;

    if (isLimitedCartLink(element)) return true;

    var text = element.textContent || "";
    return text.indexOf("Multifunktionsmesser Inox Pro 11") !== -1 || text.indexOf("Schweizer Fahne 84x84 cm") !== -1;
  }

  function getLimitedCartItemNodes() {
    var nodes = [];

    limitedProductHandles.forEach(function (handle) {
      document.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function (link) {
        var item = link.closest("cart-item, .cart-item, .cart__item, .cart-drawer__item, [data-cart-item], li, tr, .drawer__cart-item");
        nodes.push(item || link.parentElement);
      });
    });

    document.querySelectorAll("cart-item, .cart-item, .cart__item, .cart-drawer__item, [data-cart-item], li, tr, .drawer__cart-item").forEach(function (item) {
      if (isLimitedCartNode(item)) nodes.push(item);
    });

    return nodes.filter(function (node, index, list) {
      return node && list.indexOf(node) === index;
    });
  }

  function capCartDrawerQuantityControls() {
    getLimitedCartItemNodes().forEach(function (item) {
      item.querySelectorAll('input[name*="updates"], input[name="quantity"], quantity-input input, input[type="number"]').forEach(normalizeQuantityInput);

      item.querySelectorAll('button[name="plus"], .quantity__button[name="plus"], button[aria-label*="Increase"], button[aria-label*="Erhöhen"], button[aria-label*="augment"], button[aria-label*="aument"], button').forEach(function (button) {
        var label = (button.getAttribute("aria-label") || button.textContent || "").trim();
        var looksLikePlus = button.name === "plus" || label === "+" || label.indexOf("+") !== -1 || /increase|erh.hen|augment|aument/i.test(label);

        if (looksLikePlus) {
          button.setAttribute("disabled", "disabled");
          button.setAttribute("aria-disabled", "true");
          button.style.pointerEvents = "none";
          button.style.opacity = "0.45";
        }
      });
    });
  }

  function updateLimitedTierPriceDisplay(tier) {
    var label = tier.querySelector(".mnml-volume-pricing__tier-label");
    var total = tier.querySelector(".mnml-volume-pricing__tier-total");

    if (label && !label.querySelector(".sk-limited-discount-badge")) {
      var badge = document.createElement("span");
      badge.className = "sk-limited-discount-badge";
      badge.textContent = "93% OFF";
      badge.style.cssText = "display:inline-flex;align-items:center;margin-left:6px;padding:2px 5px;border-radius:3px;background:#ffe6d9;color:#ff2a1a;border:1px solid #ff2a1a;font-size:12px;font-weight:700;line-height:1;";
      label.appendChild(badge);
    }

    if (total && !total.querySelector(".sk-limited-compare-price")) {
      total.innerHTML = 'CHF 1.00 <span class="sk-limited-compare-price" style="text-decoration: line-through; opacity: .55; font-size: .85em; margin-left: 4px;">CHF 14.90</span> <span class="sk-limited-unit">Stk</span>';
    }
  }

  function capVolumePricingWidget() {
    if (!isLimitedProductPage()) return;

    limitedVariantIds.forEach(function (variantId) {
      document.querySelectorAll('.mnml-volume-pricing[data-variant-id="' + variantId + '"]').forEach(function (widget) {
        widget.querySelectorAll(".mnml-volume-pricing__tier").forEach(function (tier) {
        var qty = Number(tier.getAttribute("data-qty") || "1");

        if (qty > 1) {
          tier.style.display = "none";
          tier.setAttribute("aria-hidden", "true");
        } else {
          tier.style.display = "";
          tier.removeAttribute("aria-hidden");
          tier.classList.add("mnml-volume-pricing__tier--selected");
          if (discountedReferenceVariantIds.indexOf(String(variantId)) !== -1) {
            updateLimitedTierPriceDisplay(tier);
          }
        }
        });

        widget.querySelectorAll("input, select").forEach(function (control) {
        if (control.name === "quantity" || control.getAttribute("data-qty")) {
          normalizeQuantityInput(control);
        }
        });
      });
    });
  }

  function initVolumePricingObserver() {
    if (window.__skLimitInoxPro11Observer || !window.MutationObserver) return;
    window.__skLimitInoxPro11Observer = true;

    var observer = new MutationObserver(function () {
      capProductPageQuantity();
      capVolumePricingWidget();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function capCartQuantities() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart.js" : "/cart.js")
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        var beanieAlreadyKept = false;
        cart.items.forEach(function (item) {
          if (isLimitedVariant(item.variant_id)) {
            limitedLineKeys[item.key] = true;
          }

          var desiredQuantity = 1;
          if (String(item.variant_id) === "55225112887629") {
            desiredQuantity = beanieAlreadyKept ? 0 : 1;
            beanieAlreadyKept = true;
          }

          if (isLimitedVariant(item.variant_id) && item.quantity > desiredQuantity) {
            fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify({ id: item.key, quantity: desiredQuantity })
            }).then(function () {
              capCartDrawerQuantityControls();
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            });
          }
        });

        capCartDrawerQuantityControls();
      })
      .catch(function () {});
  }

  function guardAddToCartForms() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      var variantId = getVariantIdFromForm(form);
      if (!isLimitedVariant(variantId)) return;

      var quantityInput = form.querySelector('[name="quantity"]');
      normalizeQuantityInput(quantityInput);
    }, true);
  }

  function patchFetch() {
    if (!window.fetch || window.__skLimitInoxPro11FetchPatched) return;
    window.__skLimitInoxPro11FetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url;
      var body = init && init.body;

      if (url && typeof url === "string" && body && (url.indexOf("/cart/add") !== -1 || url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1)) {
        try {
          var contentType = init.headers && (init.headers["Content-Type"] || init.headers.get && init.headers.get("Content-Type"));

          if (contentType && String(contentType).indexOf("application/json") !== -1 && typeof body === "string") {
            var json = JSON.parse(body);

            if (url.indexOf("/cart/add") !== -1) {
              if (json.id && isLimitedVariant(json.id)) json.quantity = 1;
              if (json.items && Array.isArray(json.items)) {
                json.items.forEach(function (item) {
                  if (item.id && isLimitedVariant(item.id)) item.quantity = 1;
                });
              }
            }

            if ((url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1) && json.id && isLimitedVariant(json.id) && Number(json.quantity) > 1) {
              json.quantity = 1;
            }

            if ((url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1) && json.id && limitedLineKeys[String(json.id)] && Number(json.quantity) > 1) {
              json.quantity = 1;
            }

            init.body = JSON.stringify(json);
          }
        } catch (error) {}
      }

      return originalFetch.apply(this, arguments).then(function (response) {
        if (url && typeof url === "string" && (url.indexOf("/cart/add") !== -1 || url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1)) {
          setTimeout(capCartQuantities, 150);
        }
        return response;
      });
    };
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.__skLimitInoxPro11XhrPatched) return;
    window.__skLimitInoxPro11XhrPatched = true;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__skLimitUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      if (this.__skLimitUrl && typeof this.__skLimitUrl === "string" && body && this.__skLimitUrl.indexOf("/cart/add") !== -1) {
        try {
          if (typeof body === "string" && limitedVariantIds.some(function (variantId) { return body.indexOf("id=" + variantId) !== -1; })) {
            body = body.replace(/quantity=\\d+/g, "quantity=1");
          }
        } catch (error) {}
      }

      this.addEventListener("loadend", function () {
        if (this.__skLimitUrl && typeof this.__skLimitUrl === "string" && this.__skLimitUrl.indexOf("/cart/") !== -1) {
          setTimeout(function () {
            capCartQuantities();
            capCartDrawerQuantityControls();
          }, 150);
        }
      });

      return originalSend.call(this, body);
    };
  }

  function init() {
    applyScopedDescriptionHeadingStyles();
    capProductPageQuantity();
    capVolumePricingWidget();
    capCartDrawerQuantityControls();
    guardAddToCartForms();
    patchFetch();
    patchXhr();
    initVolumePricingObserver();
    capCartQuantities();
    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || !isLimitedCartNode(target)) return;

      var button = target.closest && target.closest("button");
      if (!button) return;

      var label = (button.getAttribute("aria-label") || button.textContent || "").trim();
      var looksLikePlus = button.name === "plus" || label === "+" || label.indexOf("+") !== -1 || /increase|erh.hen|augment|aument/i.test(label);

      if (looksLikePlus) {
        event.preventDefault();
        event.stopImmediatePropagation();
        capCartQuantities();
        capCartDrawerQuantityControls();
      }
    }, true);
    document.addEventListener("cart:updated", capCartQuantities);
    document.addEventListener("cart:refresh", function () {
      capProductPageQuantity();
      capVolumePricingWidget();
      capCartDrawerQuantityControls();
    });
    document.addEventListener("shopify:section:load", function () {
      capProductPageQuantity();
      capVolumePricingWidget();
      capCartDrawerQuantityControls();
    });
    setTimeout(capVolumePricingWidget, 600);
    setTimeout(capVolumePricingWidget, 1500);
    setTimeout(capCartDrawerQuantityControls, 600);
    setTimeout(capCartDrawerQuantityControls, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
